import { IAccountRole } from "./lib/roles";

export const notificationTypes = {
  1: (extraInfo: { old_role: IAccountRole; new_role: IAccountRole }) =>
    `Your role was changed from ${extraInfo.old_role} to ${extraInfo.new_role}.`,
} as const;

export type INotificationType = keyof typeof notificationTypes;
